import { render, staticRenderFns } from "./MessageGroup.vue?vue&type=template&id=74e079cb&scoped=true&"
import script from "./MessageGroup.vue?vue&type=script&lang=js&"
export * from "./MessageGroup.vue?vue&type=script&lang=js&"
import style0 from "./MessageGroup.vue?vue&type=style&index=0&id=74e079cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e079cb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAvatar,VIcon,VProgressCircular,VTooltip})
